/* Built In Imports */
import NextLink from 'next/link';

import { Box, Flex, useTheme, Link } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SimpleButton from '@msr/components/Buttons/SimpleButton';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import SingleLineText from '@msr/components/UI/SingleLineText';
import { render } from 'datocms-structured-text-to-html-string';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const Participate = ({ sectionContent, lang, region }) => {
  const theme = useTheme();
  const spacing = theme.space[5];
  const borderStyle = 'none';

  const CardInfoDetail = ({ data, index }) => {
    const isEvenIndex = index % 2 == 0;
    const flexDirection = isEvenIndex ? 'row' : 'row-reverse';
    const textAlign = isEvenIndex ? 'right' : 'left';
    const float = isEvenIndex ? 'left' : 'right';
    return (
      <Box
        display="flex"
        justifyContent="center"
        key={nanoid()}
        m={{ base: '12px auto', md: '16px auto 20px auto' }}
        flexDirection={{ base: 'column-reverse', md: flexDirection }}
        alignItems={'flex-start'}
        w={{ base: '100%', md: '1300px', lg:'1300px', xl:'1300px', "2xl": '1300px' }}
        maxW={'1920px'}
      >
        <Box
          className="slider description"
          w={{ base: '100%', md: '50%' }}
          color={'black'}
          textAlign="left"
          px={{ base: '8px', md: '8px' }}
          height="auto"
          margin={{
            base: '0',
            md: flexDirection == 'row-reverse' ? '0 0 0 40px' : '0 40px 0 20px',
          }}
        >
          <Box mt={{ base: '20px', md: '0' }}>
            <Box fontSize="21px" fontWeight="600" color="yellow.100">
              {data?.image?.title}
            </Box>
            <Box
              color="blue.200"
              maxW={{ base: '340px', md: '580px' }}
              fontFamily={'FedraSansStd-book'}
              mt={{ base: '20px', md: '0', lg: '30px' }}
              lineHeight={{ base: '1.5', md: '1.3', lg: '1.5' }}
            >
              <StructuredTextParser
                str={render(data?.image.description)}
                lang={lang}
              />
            </Box>
          </Box>
          <Box m={{ base: '0', md: '20px auto' }}>
            <SimpleButton
              style={{
                buttonStyle: 'MSR-Orange-Transparent',
                buttonText: data?.image?.label,
                linkUrl: data?.image?.url,
              }}
              mt={{ base: '40px', md: '0' }}
              mb="0"
            />
          </Box>
        </Box>
        <Box
          w={{ base: '100%', md: '50%' }}
          px={{ base: '8px', sm: '5px' }}
          display={{ base: 'flex' }}
          justifyContent={{ base: 'center', md: 'left' }}
          className="program_image"
          mt={{ base: '0', md: '20px' }}
          ml={{ base: '0', md: '20px' }}
        >
          <LazyLoadImageComponent
            src={data?.image?.image?.url}
            alt={data?.image?.image?.alt}
            title={data?.image?.image?.title}
            textAlign="center"
          />
        </Box>
      </Box>
    );
  };
  return (
    <Box p="16px 20px" bg={'#090D49'}>
      <MsrSectionTitle
        pt="0"
        mt="0"
        fontSize="34px"
        titleObj={sectionContent[0]}
        w={{
          base: 'auto',
          md: '515px',
          lg: '900px',
        }}
        maxwidth={'900px'}
      />
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        marginX={`calc(${spacing} / -2)`}
      >
        {sectionContent[1]?.cards?.length &&
          sectionContent[1]?.cards?.map((data, index) => {
            return (
              <CardInfoDetail
                section={sectionContent[1]}
                data={data}
                index={index}
                key={index}
              />
            );
          })}
      </Flex>
      <style jsx global>
        {`
          .description p {
            color: #c1c3dd;
          }
        `}
      </style>
    </Box>
  );
};

export default Participate;